import React from 'react';
import PropTypes from 'prop-types';
import CategoryMenuLoader from './CategoryMenuLoader';
import NavBarItem from './NavBarItem';
import WebMediaQuery from './WebMediaQuery';
import {Message} from '@aperza/ui';
import PromoteCompanyLink from './PromoteCompanyLink';
import SignUpLink from './SignUpLink';
import AppService from '../service/AppService';
import type AppConfig from '../domain/AppConfig';

import {createFragmentContainer, graphql} from 'react-relay';
let appConfig:AppConfig = AppService.appConfig();

class NavBar extends React.Component {

  static propTypes = {
    viewer: PropTypes.shape({
      id: PropTypes.string,
      isLogin: PropTypes.bool,
      endUserType: PropTypes.number,
    }),
    disableNavCategory: PropTypes.bool,
    disableNavCatalog: PropTypes.bool,
    disableNavMarketplace: PropTypes.bool,
    disableNavNews: PropTypes.bool,
    disableNavExhibitions: PropTypes.bool,
    disableNavManufacturers: PropTypes.bool,
    disableNavShops: PropTypes.bool,
    disableNavPromote: PropTypes.bool,
    disableNavRegisterAccount: PropTypes.bool,
    disableMarketplaceBanner: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.refParent = React.createRef();
    this.ref = React.createRef();

    this.state = {
      left: 0,
    }
  }

  render() {

    let { viewer, disableNavCategory, disableNavCatalog, disableNavMarketplace, disableNavNews, disableNavExhibitions, disableNavManufacturers, disableNavShops, disableNavPromote, disableNavRegisterAccount } = this.props;

    let style = {
      //position: 'absolute',
      //left: this.state.left,
    };

    return (
      <div ref={this.refParent}
           className="strip aw-navbar"
           style={{justifyContent: 'space-between', position:'relative', height: '18px'}}>
        <div ref={this.ref} className="strip" style={style}

        >
          {!disableNavCategory && viewer && !appConfig.hideProductCategory &&
          <WebMediaQuery desktopOnly={true}>
            <CategoryMenuLoader {...this.props}/>
          </WebMediaQuery>
          }
          {
            !disableNavCatalog &&
            <React.Fragment>
              <NavBarItem title={<Message messageId="navbar.searchCatalog" />}
                          shortTitle={<Message messageId="navbar.searchCatalog_short" />}
                          icon="catalog"
                          url={`${appConfig.searchWebUrlPrefix}/catalog/`}>
              </NavBarItem>
            </React.Fragment>
          }
          {
            !disableNavMarketplace &&
            <React.Fragment>
              <NavBarItem title={<Message messageId="navbar.buy" />}
                            shortTitle={<Message messageId="navbar.buy_short" />}
                            icon="cart"
                            url={`https://www${appConfig.baseComDomain}/marketplace/index.html`}
                            />
            </React.Fragment>
          }
          {
            !disableNavNews &&
            <React.Fragment>
              <NavBarItem title={<Message messageId="navbar.news" />}
              shortTitle={<Message messageId="navbar.news_short" />}
              icon="news"
              openOnNewTab={true}
              url={`https://news${appConfig.baseDomain}`} />
            </React.Fragment>
          }
          {
            !disableNavExhibitions &&
            <React.Fragment>
              <NavBarItem title={<Message messageId="navbar.exhibitions" />}
              shortTitle={<Message messageId="navbar.exhibitions_short" />}
              icon="building"
              url={`${appConfig.searchWebUrlPrefix}/feature/top`} />
            </React.Fragment>
          }
          {
            !disableNavManufacturers &&
            <React.Fragment>
              <NavBarItem title={<Message messageId="navbar.ec.manufacturers" />}
                          url={`${appConfig.marketplaceWebUrlPrefix}/mfr/index.html`}>
              </NavBarItem>
            </React.Fragment>
          }
          {
            !disableNavShops &&
            <React.Fragment>
              <NavBarItem title={<Message messageId="navbar.ec.shops" />}
                          url={`${appConfig.searchWebUrlPrefix}/dst/mp/index.html`}>
              </NavBarItem>
            </React.Fragment>
          }
        </div>

          <div className="strip right ">
            {!disableNavPromote && viewer && !viewer.isLogin &&
              <React.Fragment>
                <PromoteCompanyLink {...this.props} />
              </React.Fragment>
            }
            {!disableNavRegisterAccount && viewer && !viewer.isLogin &&
              <React.Fragment>
                <SignUpLink {...this.props} />
              </React.Fragment>
            }
            {!disableNavPromote && viewer && viewer.isLogin && [1,2,3].includes(viewer.endUserType) &&
              <PromoteCompanyLink />
            }
          </div>

      </div>
    )
  }

}

export default createFragmentContainer(NavBar, {
  viewer: graphql`
      fragment NavBar_viewer on Viewer {
          id
          isLogin
          endUserType
      }
  `});
